import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import DataTableHelper from "../../../helpers/tables/DataTableHelper"
import Columns from './Columns'
import AddUpdModal from './AddUpdModal'
import { getUsers,deleteUser,resourcesRoutes,activeRoutes } from '../../../helpers/backend_helper';
import {DestroyAlertHelper,Alert} from '../../../helpers/alerts/alertHelper';
import { getStorageUser } from '../../../helpers/api_helper';
import {Container} from "reactstrap";
import ButtonHelper from '../../../helpers/ButtonHelper';

const Routes = () => {
    const authUser = getStorageUser();
    const [pending, setPending] = useState(false);
    const [modal, setModal] = useState({show:false,update:false});
    const [dataPag, setDataPag] = useState({total:0});
    const [filters,setFilters] = useState({page:1,perPage:20,search:'',orderBy:'id',order:'asc',companySession:authUser.company_id});
    const [items, setItems] = useState([]);
    const [itemBase, setItemBase] = useState({
        id: 0,
        name: null,
        active: false,
        provider_id: null,
        active: true,
        external_id: null,
        company_id: authUser.company_id,
        administrator_id: authUser.profile_id==3 ? authUser.id:null,
        newAdministrator: true,
        slug: null,
        email: '',
        nameAdmin: '',
        password: '',
        password_confirm: '',
    })
    const [item, setItem] = useState(itemBase);

	const dispatch = useDispatch()
    useEffect(() => {
        const getRoutes = async() =>{    
            let params={params:filters}
            setPending(true)
            const response = await resourcesRoutes('get',params);
            setItems(response.data)
            setDataPag(response.meta)
            setPending(false)
        }
        getRoutes();
    }, [filters])

    const addUpd = (row=false) => {
        setItem(row.id ? row:itemBase)
        setModal({...modal,show:true, update: (row.id ? true:false)})
    }

    const destroy = async(id) => {
        DestroyAlertHelper(async confirmed => {
            if (!confirmed) { return; }
            const response = await resourcesRoutes('del',id,id);
            Alert(response.message,response.status)
            if (response.status) {
                setItems(
                    items.filter(i => i.id != id)
                );
            } 
        });
    }

    const active= (row) => {
        activeRoutes(row).then(response => {
            if (response.status) {
                console.log(response.route)
                let newItem=response.route;
                let array = items.map(item => item.id !== newItem.id ? item : newItem);
                setItems(array);
            }
        })
    }
    const columns = Columns(addUpd,destroy,active);
	document.title = "Rutas | Sistema de logística";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="col-12">
                        <DataTableHelper tittle="Rutas" columns={columns} items={items} filterInp={false} pending={pending} config={dataPag} filters={filters} setFilters={setFilters}>
                                {(authUser.profile_id==2 || (authUser.can.routes.create && (authUser.profile_id == 3 && items.length == 0 ? true:false ))) && 
                                    <div className="mb-3">
                                    <ButtonHelper 
                                        addButon={true}
                                        actionAddButon={addUpd}
                                    />
                                    </div>
                                }

                            
                        </DataTableHelper>
                    </div>
                </Container>
                {modal.show &&
                    <AddUpdModal 
                        modal={modal}
                        setModal={setModal}
                        items={items}
                        setItems={setItems}
                        item={item}
                        setItem={setItem}
                        authUser={authUser}
                    />
                }
            </div>
        </React.Fragment>
    );
};

export default Routes;